define('services/outbound/campaignService',[
    'enums/outbound/CampaignStatuses',
    'enums/outbound/DialingModes',
    'enums/outbound/RecurrenceTypes',
    'enums/outbound/Weekdays',
    'lib/bluebird',
    'lib/knockout',
    'lib/lodash4',
    'services/apiCore'
], function (
    CAMPAIGN_STATUSES,
    DIALING_MODES,
    RECURRENCE_TYPES,
    WEEKDAYS,
    Promise,
    ko,
    _,
    apiCore
) {
    'use strict';


    var uris = {
        CAMPAIGNS: '/outbound/campaigns',
        CAMPAIGN_SCHEDULES: '/outbound/schedules/campaigns',

        campaigns: function () {
            return uris.CAMPAIGNS;
        },
        campaign: function (id) {
            return uris.CAMPAIGNS + '/' + id;
        },
        scheduleCallback: function (id) {
            return uris.CAMPAIGNS + '/' + id + '/callback/schedule';
        },
        campaignStatistics: function (id) {
            return uris.CAMPAIGNS + '/' + id + '/stats';
        },
        campaignStage: function(campaignId, agentId) {
            return uris.CAMPAIGNS + '/' + campaignId + '/agents/' + agentId;
        },
        campaignSchedules: function () {
            return uris.CAMPAIGN_SCHEDULES;
        },
        campaignSchedule: function (campaignId) {
            return uris.CAMPAIGN_SCHEDULES + '/' + campaignId;
        },
        campaignDivisionViews: function () {
            return uris.CAMPAIGNS + '/divisionviews';
        }
    };


    var service = {
        uris: uris,

        getCampaigns: function (options) {
            options = _.assign({ pageSize: 100, pageNumber: 1 }, options);
            var uri = uris.campaigns();
            return apiCore.v2.get(uri, options);
        },
        getCampaignsByIds: function (ids) {
            var uri = uris.campaigns();
            return apiCore.v2.get(uri, { id: ids });
        },
        getCampaign: function (id) {
            var uri = uris.campaign(id);
            return apiCore.v2.get(uri);
        },
        getCampaignStatistics: function (id) {
            var uri = uris.campaignStatistics(id);
            return apiCore.v2.get(uri);
        },
        createCampaign: function (data) {
            var uri = uris.campaigns();
            return apiCore.v2.post(uri, data);
        },
        updateCampaign: function (id, data) {
            var uri = uris.campaign(id);
            return apiCore.v2.put(uri, data);
        },
        deleteCampaign: function (uri) {
            return apiCore.v2.del(uri);
        },
        scheduleCallback: function (id, data) {
            var uri = uris.scheduleCallback(id);
            return apiCore.v2.post(uri, data);
        },
        getCampaignSchedule: function (campaignId) {
            var uri = uris.campaignSchedule(campaignId);
            return apiCore.v2.get(uri);
        },
        getCampaignSchedules: function () {
            var uri = uris.campaignSchedules();
            return apiCore.v2.get(uri);
        },
        updateCampaignSchedule: function (data) {
            var uri = uris.campaignSchedule(data.campaign.id);
            return apiCore.v2.put(uri, data);
        },
        getWrapUpStatistics: function (/*campaignId*/) {
            // TODO get these from analytics when its made available
            // TODO don't forget to implement the spec too
            return Promise.resolve([
                {
                    wrapUp: 'Do not call contact',
                    value: 4
                },
                {
                    wrapUp: 'Do not call number',
                    value: 8
                },
                {
                    wrapUp: 'Call back later today',
                    value: 7
                },
                {
                    wrapUp: 'Call back next week',
                    value: 3
                }
            ]);
        },
        getCampaignStatuses: function () {
            return CAMPAIGN_STATUSES;
        },
        getDialingModes: function () {
            return DIALING_MODES;
        },
        getRecurrenceTypes: function () {
            return RECURRENCE_TYPES;
        },
        getWeekdays: function () {
            return WEEKDAYS;
        },
        setStage: function(campaignId, agentId, stage) {
            var uri = uris.campaignStage(campaignId, agentId);
            return apiCore.v2.put(uri, {
                stage: stage
            });
        },
        getCampaignDivisionViews: function (ids) {
            var uri = uris.campaignDivisionViews();
            return apiCore.v2.get(uri, { id: ids });
        }
    };


    return service;
});

